/**!
 *  Create new skill-building activity.
 */

import React, {useState} from 'react'
import styles from './skillBuilding.module.scss'

import Button from 'Components/UI/Button'
import Edit from './edit'

const TabCreate = ({community, loading, message, onBack, onClose, onCreate: createActivity}) =>
{
    const [data, setData] = useState({})
    const [ready, setReady] = useState(false)
    const [key, setKey] = useState(0)

    const onCreate = async (data) => {
        const success = await createActivity(data)
        if (success) {
            setKey(key + 1)
            setData({})
            setReady(false)
        }
    }

    return (
        <>
            <div className={styles.tab}>
                <h2>Create a new technical skill</h2>
                <Edit
                    community={community}
                    key={key}
                    onChange={setData}
                    onReadyState={setReady}
                />
            </div>
            <div className={styles.tray}>
                <Button
                    disabled={!ready ||loading}
                    label="Create"
                    loading={loading}
                    onClick={() => onCreate(data)}
                />
                <Button
                    hollow={true}
                    label="Back"
                    onClick={onBack}
                />
                <Button
                    hollow={true}
                    label="Close"
                    onClick={onClose}
                />
                {message && <div className={styles.message}>{message}</div>}
            </div>
        </>
    )
}

export default TabCreate